module.exports = global["ReactDOM"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dom/index.js-exposed
// module id = 38
// module chunks = 2